'use client';

import { IcArrowRight, IconButton, Typography } from '@musinsa/mds';
import { useCallback } from 'react';
import type { SnackbarAction } from './types';

interface SnackbarActionProps {
  action: SnackbarAction;
}

export function SnackbarActionButton({ action }: SnackbarActionProps) {
  const handleAction = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      action.onAction();
    },
    [action],
  );

  const hasText = action.text && action.text.trim().length > 0;

  return (
    <div
      onClick={handleAction}
      className="flex items-center justify-center transition-all duration-300 px-2 cursor-pointer self-stretch"
      style={{ pointerEvents: 'auto' }}
    >
      {hasText ? (
        <Typography
          variant="body13pxReg"
          textDecoration="underline"
          colorScheme="white"
          title={action.text}
        >
          {action.text}
        </Typography>
      ) : (
        action.icon || (
          <IconButton size="size16x16" className="shrink-0">
            <IcArrowRight strokeColor="white" />
          </IconButton>
        )
      )}
    </div>
  );
}
